(() => {
  const moneyText = (button, price) => {
    const label = button.dataset.label || 'ADD TO BAG';
    const text = button.querySelector('[data-nuvo-button-text]');
    if (text) text.textContent = price ? `${label} — ${price}` : label;
  };

  const soldOutText = (button) => {
    const text = button.querySelector('[data-nuvo-button-text]');
    if (text) text.textContent = button.dataset.soldOut || 'SOLD OUT';
  };

  const initProductHero = (root) => {
    if (!root || root.dataset.nuvoReady === 'true') return;
    root.dataset.nuvoReady = 'true';

    const mainImage = root.querySelector('[data-nuvo-main-image]');
    root.querySelectorAll('[data-nuvo-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!mainImage) return;
        mainImage.src = thumb.dataset.imageSrc;
        mainImage.removeAttribute('srcset');
        mainImage.alt = thumb.dataset.imageAlt || mainImage.alt;
        root.querySelectorAll('[data-nuvo-thumb]').forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    root.querySelectorAll('[data-nuvo-quantity]').forEach((quantity) => {
      const input = quantity.querySelector('input[type="number"]');
      quantity.querySelectorAll('button').forEach((button) => {
        button.addEventListener('click', () => {
          if (!input) return;
          const next = Math.max(1, Number(input.value || 1) + Number(button.dataset.step || 0));
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    const sizeGuide = root.querySelector('[data-nuvo-size-guide]');
    const sizeGuideOpeners = root.querySelectorAll('[data-nuvo-size-guide-open]');
    let sizeGuideTrigger = null;
    let sizeGuideTimer = null;

    const closeSizeGuide = () => {
      if (!sizeGuide || sizeGuide.hidden) return;
      window.clearTimeout(sizeGuideTimer);
      sizeGuide.classList.remove('is-open');
      document.body.classList.remove('nuvo-size-guide-open');
      sizeGuideTimer = window.setTimeout(() => {
        sizeGuide.hidden = true;
        if (sizeGuideTrigger) sizeGuideTrigger.focus();
      }, 180);
    };

    const openSizeGuide = (trigger) => {
      if (!sizeGuide) return;
      window.clearTimeout(sizeGuideTimer);
      sizeGuideTrigger = trigger;
      sizeGuide.hidden = false;
      document.body.classList.add('nuvo-size-guide-open');
      window.requestAnimationFrame(() => {
        sizeGuide.classList.add('is-open');
        sizeGuide.querySelector('.nuvo-size-guide__dialog')?.focus();
      });
    };

    sizeGuideOpeners.forEach((opener) => {
      opener.addEventListener('click', () => openSizeGuide(opener));
    });

    if (sizeGuide) {
      sizeGuide.querySelectorAll('[data-nuvo-size-guide-close]').forEach((closer) => {
        closer.addEventListener('click', closeSizeGuide);
      });

      const sizeGuideTabs = Array.from(sizeGuide.querySelectorAll('[data-nuvo-size-tab]'));
      const sizeGuidePanels = Array.from(sizeGuide.querySelectorAll('[data-nuvo-size-panel]'));
      const activateSizeGuideTab = (activeTab, moveFocus = false) => {
        const target = activeTab.dataset.nuvoSizeTab;

        sizeGuideTabs.forEach((tab) => {
          const isActive = tab === activeTab;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });

        sizeGuidePanels.forEach((panel) => {
          panel.hidden = panel.dataset.nuvoSizePanel !== target;
        });

        if (moveFocus) activeTab.focus();
      };

      sizeGuideTabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateSizeGuideTab(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();

          let nextIndex = index;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + sizeGuideTabs.length) % sizeGuideTabs.length;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % sizeGuideTabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = sizeGuideTabs.length - 1;
          activateSizeGuideTab(sizeGuideTabs[nextIndex], true);
        });
      });

      sizeGuide.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeSizeGuide();
      });
    }

    const submit = root.querySelector('[data-nuvo-add]');
    const price = root.querySelector('[data-nuvo-price]');
    const selectedVariant = root.querySelector('[data-nuvo-selected-variant]');
    root.querySelectorAll('[data-nuvo-variant]').forEach((variant) => {
      variant.addEventListener('change', () => {
        if (!variant.checked || !submit) return;
        if (selectedVariant) selectedVariant.value = variant.value;
        submit.disabled = variant.dataset.available !== 'true';
        if (submit.disabled) {
          soldOutText(submit);
        } else {
          moneyText(submit, variant.dataset.price);
        }
        if (price) price.textContent = variant.dataset.price;
        document.dispatchEvent(new CustomEvent('nuvo:variant-change', {
          detail: { id: variant.value, price: variant.dataset.price, available: variant.dataset.available === 'true' }
        }));
      });
    });
  };

  const initSticky = (root) => {
    if (!root || root.dataset.nuvoReady === 'true') return;
    root.dataset.nuvoReady = 'true';
    const hero = document.querySelector('[data-nuvo-product-hero]');
    const select = root.querySelector('[data-nuvo-sticky-variant]');
    const submit = root.querySelector('[data-nuvo-add]');

    if (hero && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        root.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }, { threshold: 0 });
      observer.observe(hero);
    }

    if (select && submit) {
      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];
        const available = option.dataset.available === 'true';
        submit.disabled = !available;
        if (available) moneyText(submit, option.dataset.price);
        else soldOutText(submit);
      });
    }

    document.addEventListener('nuvo:variant-change', (event) => {
      if (!select || !event.detail) return;
      select.value = event.detail.id;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });

    root.querySelectorAll('[data-nuvo-quantity]').forEach((quantity) => {
      const input = quantity.querySelector('input[type="number"]');
      quantity.querySelectorAll('button').forEach((button) => {
        button.addEventListener('click', () => {
          if (!input) return;
          input.value = Math.max(1, Number(input.value || 1) + Number(button.dataset.step || 0));
        });
      });
    });
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-nuvo-product-hero]').forEach(initProductHero);
    scope.querySelectorAll('[data-nuvo-sticky-purchase]').forEach(initSticky);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
